import React from 'react';
import './pages.css';
import './brandspage.css';
import bgmshops from '../images/bgbrands.webp';
import BrandsIcons from '../Components/BrandsIcons.js';

function BrandsPage() {
    return (
        <>
         <section className='pagesIndex' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                    <div className='content'>
                        <p className='subtitles'>BIG</p>
                        <h2><span>BRANDS<i>-</i></span></h2>
                        <div className='textoWorks'>
                            <h3>BIG <strong>BRANDS</strong></h3>
                            <p>Sabemos que los grandes proyectos requieren compromiso. Nos convertimos en una extensión de tu equipo para garantizar el éxito en cada etapa del proceso.</p>
                        </div>
                    </div>
        </section>
        <section className='brandsPage' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
            <div className='content'>
                <BrandsIcons/> 
            </div>
        </section>
        <section className='pagesIndex familyIndex' name='familyIndex'>
            <div className='content flexIndex'>
                <div className='colIndex'>
                    <p className='subtitles'>WE WORK</p>
                    <h2><span>in Family</span></h2>
                </div>
                <div className='colIndex'>
                    <p className='claimBrand'>En <strong>Index®</strong>, no solo creamos proyectos, construimos relaciones. Trabajamos codo a codo con cada cliente, escuchando, guiando y potenciando sus ideas. La transparencia y la pasión nos definen, porque su éxito es el nuestro.</p>
                </div>
            </div>
        </section>
        </>
    )
}
export default BrandsPage;